import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export function searchQueryKey(category, text, tagIds, includeDescription, eventDateFilter = "all") {
  return ["search", category, text, [...tagIds].sort((a, b) => a - b).join(","), includeDescription, eventDateFilter];
}

async function fetchSearchResults({ addressIp, text, tags, category, includeDescription, eventDateFilter }) {
  const res = await axios({
    method: "POST",
    data: {
      ip: addressIp,
      text: text || undefined,
      tags: tags.length ? tags : undefined,
      category,
      includeDescription,
      period: eventDateFilter,
    },
    withCredentials: true,
    url: process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_SEARCH_URL,
  });
  return res.data ?? [];
}

export function useSearchQuery({ addressIp, text, tags, category, includeDescription, eventDateFilter, enabled }) {
  const tagIds = tags.map((tag) => tag.id);
  return useQuery({
    queryKey: searchQueryKey(category, text, tagIds, includeDescription, eventDateFilter),
    queryFn: () => fetchSearchResults({ addressIp, text, tags, category, includeDescription, eventDateFilter }),
    enabled,
  });
}
